import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ProgressProvider } from "./contexts/ProgressContext";
import { SearchProvider } from "./contexts/SearchContext";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import AuthCallback from "./pages/AuthCallback";
import Chapter from "./pages/Chapter";
import Admin from "./pages/Admin";
import Review from "./pages/Review";
import Questions from "./pages/Questions";
import Teacher from "./pages/Teacher";
import TakeQuiz from "./pages/TakeQuiz";
import HomeworkSubmit from "./pages/HomeworkSubmit";
import { Toaster } from "@/components/ui/sonner";
import TranslatePopover from "./components/TranslatePopover";
import TeacherAvatar from "./components/TeacherAvatar";
import Footer from "./components/Footer";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/chapter/:id" element={<Chapter />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/teacher" element={<Teacher />} />
        <Route path="/review" element={<Review />} />
        <Route path="/questions" element={<Questions />} />
        <Route path="/assignment/:assignmentId/quiz" element={<TakeQuiz />} />
        <Route path="/assignment/:assignmentId/homework" element={<HomeworkSubmit />} />
        {/* OAuth callback route. Google/Emergent redirect here with a
            #session_id=... hash that AuthCallback consumes. We also handle
            the hash on ANY route above via the guard at the top of this
            component, so legacy callbacks still work. */}
        <Route path="/auth-callback" element={<AuthCallback />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <ProgressProvider>
            <BrowserRouter>
              <SearchProvider>
                <AppRouter />
                <TranslatePopover />
                <TeacherAvatar />
                <Toaster />
              </SearchProvider>
            </BrowserRouter>
          </ProgressProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
